<template>

  <v-container>
    <v-row>
      <v-spacer></v-spacer>

      <v-col order="1">
        <v-card-title>Login</v-card-title>

        <v-card-actions></v-card-actions>

        <v-card-text>
          <v-text-field v-model="inputs.username" type="text" outlined dense
                        placeholder="username"/>
          <v-text-field v-model="inputs.password" type="password" outlined dense
                        placeholder="password" @keyup.enter.native="login(inputs)"/>


        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="login(inputs)" id="btnLogin" :disabled="authenticating">
            Login
          </v-btn>
        </v-card-actions>

        <v-card-text>
          <v-alert type="error" v-model="error">{{error_message}}</v-alert>

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>Extra</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field v-model="inputs.login_as_username" type="text" outlined dense
                              placeholder="Impersonate username"
                              hint="* for administrators only" persistent-hint/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>


        </v-card-text>

      </v-col>

      <v-spacer></v-spacer>
    </v-row>
  </v-container>

</template>

<script>

	import {mapGetters} from 'vuex'

	export default {
		name: "LoginView.py",

		data: function () {
			return {
				show_extra: false,

				inputs: {
					username: null,
					password: null,
					login_as_username: null,
				},
			}
		},

		computed: {
			...mapGetters({
				authenticating: 'auth/authenticating',
				error: 'auth/error',
				error_message: 'auth/errorMessage'
			}),
		},

		methods: {
			login(inputs) {
				const me = this

				this.$store.dispatch('auth/login', inputs)
					.then(() => {
						Object.keys(this.$route.query).length === 0
							? this.$router.push('/')
							: this.$router.push(this.$route.query['from'])
					})
			}
		}
	}
</script>

<style scoped>
  html {
    overflow-y: scroll;
  }
</style>